import asBentoPage from 'common/bento/hoc/asBentoPage';

import { BeneficiarySchema } from '../../../../components/BeneficiaryForm/beneficiarySchema';
import OBNavigation from '../../../../components/OBNavigation/OBNavigation';
import { GetBeneficiariesDataQuery } from '../../graphql/queries/getBeneficiariesData.gql';
import CreateBeneficiary from './views/CreateBeneficiary';
import EditBeneficiary from './views/EditBeneficiary';
import SupposedBeneficiary from './views/SupposedBeneficiary';

export enum ManageBeneficiaryViews {
  Edit = 'edit',
  Supposed = 'supposed',
  Create = 'create',
}

interface BeneficiaryFormProps {
  data: GetBeneficiariesDataQuery['viewer'];
  beneficiaryId: string | null;
  view: ManageBeneficiaryViews;
  isSending: boolean;
  isDeleting: boolean;
  onSubmit: (formValues: BeneficiarySchema) => void;
  onDeleteBeneficiary: () => void;
}

const ManageBeneficiary = asBentoPage<BeneficiaryFormProps>(
  ({ Layout, onPrev, view, ...props }) => {
    const getView = (_view: ManageBeneficiaryViews) => {
      switch (_view) {
        case ManageBeneficiaryViews.Edit: {
          if (!props.beneficiaryId) {
            throw new Error(
              'Edit beneficiary page cannot be accessed without a beneficiary ID',
            );
          }

          return (
            <EditBeneficiary {...props} beneficiaryId={props.beneficiaryId} />
          );
        }
        case ManageBeneficiaryViews.Supposed: {
          if (!props.beneficiaryId) {
            throw new Error(
              'Edit supposed beneficiary page cannot be accessed without a beneficiary ID',
            );
          }

          return (
            <SupposedBeneficiary
              {...props}
              beneficiaryId={props.beneficiaryId}
            />
          );
        }

        case ManageBeneficiaryViews.Create:
        default: {
          return <CreateBeneficiary onPrev={onPrev} {...props} />;
        }
      }
    };

    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>{getView(view)}</Layout>
    );
  },
);

export default ManageBeneficiary;
